<template>
	<el-dialog :close-on-click-modal='false' :visible="true" @close='close'>
		<b slot="title" class="ak-depart-table-title">Modify Name</b>
		<el-form :model='form' :rules='rules' ref='form' style='width: 60%;margin: 0 auto;' label-position="top">
			<el-form-item label="FirstName" label-width="120px" prop='FirstName'>
				<el-input v-model="form.FirstName" auto-complete="off"></el-input>
			</el-form-item>

            <el-form-item label="LastName" label-width="120px" prop='LastName'>
				<el-input v-model="form.LastName" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div  slot="footer" class="dialog-footer" style="display:flex;">
              <div style="flex:1;">
                <el-button @click="close">Close</el-button>
            </div>
            <div style="flex:1;">
            <el-button type="primary" @click="submit()">Submit</el-button>
            </div>
		</div>
	</el-dialog>
</template>

<script>
import { Rule } from "./rule.js";
export default {
    props:{
        close:{
            type:Function,
            required:true
        },
        firstName:{
            required:true
        },
        lastName:{
            required:true
        }
    },
    data () {
        let firstNameLength = 16;
        let firstNameErrorMsg = `FirstName must not exceed ${firstNameLength} characters`;
        /*  let lastNameLength = 8;
        let lastNameErrorMsg = `FirstName must not exceed ${lastNameLength} characters`; */
        let rule = new Rule();
        return{
            form:{
                FirstName:"",
                LastName:""
            },
            rules:{
                FirstName:[{ required: true, message: 'Please fill in a firstName', trigger: 'blur' },
                    {validator: rule.checkLength(firstNameLength,firstNameErrorMsg), trigger: 'blur' }]/* , */
                /*  LastName:[{ required: true, message: 'Please fill in a lastName', trigger: 'blur' },
                    {validator: rule.checkLength(lastNameLength,lastNameErrorMsg), trigger: 'blur' }] */
            }
        };
    },
    mounted () {
        this.form.FirstName = this.firstName;
        this.form.LastName = this.lastName;
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid)=>{
                if(!valid) return false;
                let form = Object.assign({},this.form);
                this.$http.put("modName",
                    form,(data)=>{
                        this.$baseNotice.message(data.msg);
                        this.close();
                        this.$emit("update");
                    });
            });
        }
    }
};
</script>

<style>
</style>